module.exports = __webpack_public_path__ + "img/thirdfeatureicon.3ae90402.webp";